import { calendarFormat } from 'moment';
import { Validator } from 'vee-validate';
import Vue from 'vue';
import StHelper from './StHelper';

const cnpjRule = {
    getMessage: field =>  `O CNPJ está inválido [${field}]`,
    validate : value => StHelper.validarCnpj(value)
};

export default class VueCustomRegisterer {
    constructor() {
        Vue.filter('grana', StHelper.formatReal);
        Vue.filter('percAcrescimoDesconto', StHelper.formatPercAcrescimoDesconto);
        Vue.filter('acrescimoDesconto', StHelper.formatValorAcrescimoDesconto);
        Vue.filter('granars', StHelper.formatRealSimbolo);
        Vue.filter('data', StHelper.formatData);
        Vue.filter('datahora', StHelper.formatDataHora);
        Vue.filter('firstName', StHelper.firstName);
        Vue.filter('telefone', StHelper.formataTelefone);
        Vue.filter('volume', StHelper.formatVolume);
        Vue.filter('cobrancaeletronicastatus', StHelper.formataStatusCobrancaEletronica);
        Vue.filter('role_usuario', this._formatarRoleUsuario);
        Vue.filter('unidadenegocio', StHelper.formataUneg);
        Vue.filter('perfilusuario', StHelper.formataPerfilUsuario);
        Vue.filter('cep', StHelper.formatCep);
        Vue.filter('pedc_ref_externo_without_pipe', StHelper.formatPedcRefExternoWithoutPipe);
        // Vue.filter('muitosDescontos', arr=>{
        //     let m = '';
        //     arr.forEach(el=>{
        //         if (el) m+=`${StHelper.formatReal(el)} +`;
        //     });
        //     return m.substring(0,m.length-2);
        // });
        Vue.filter('role', this._formatarRole);
        Vue.filter('shopee_order_status', this._formatarShopeeOrderStatus);

        Validator.extend('cnpj', cnpjRule);
        this._definesClicableToast();

    }

    _formatarRoleUsuario(val) {
        switch(val) {
            case 'VENDEDOR_INTERNO':
                return 'VENDEDOR INTERNO'
            case 'VENDEDOR_EXTERNO':
                return 'VENDEDOR EXTERNO'
            case 'MARKETING':
                return 'MARKETING'
            case 'COMPRAS':
                return 'COMPRAS'
                default:
                    return val;
        }
    }

    _definesClicableToast () {
        let toastValue = null;
        Vue.directive('clickableToast',{
            bind: function(el, binding, vnode) {
                toastValue = binding.value;
                el.addEventListener('click',function(){
                    Materialize.toast(toastValue,3000);
                });
            },
            update: function(el, binding, vnode) {
                toastValue = binding.value;
            }
        });
    }

    _formatarRole(val) {
        return val.replaceAll('_', ' ');
    }
    _formatarShopeeOrderStatus(val) {
        switch(val) {
            case 'UNPAID':
                return 'AGUARDANDO PAGAMENTO';
            case 'READY_TO_SHIP':
                return 'PRONTA PARA ENVIO';
            case 'PROCESSED':
                return 'PROCESSADA';
            case 'SHIPPED': 
                return 'EM TRANSPORTE';
            case 'COMPLETED':
                return 'ENTREGUE';
            case 'IN_CANCEL' :
                return 'CANCELAMENTO SOLICITADO';
            case 'CANCELLED':
                return 'CANCELADA';
            default:
                return 'NÃO IDENTIFICADO';

        }
    }
}



// WEBPACK FOOTER //
// ./src/components/helpers/VueCustomRegisterer.js